// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XrBI9Yj7LgUu_aiMBw1B {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    /* Semi-transparent black */
    z-index: 120000;
  }
  
  .J6k2sMuAK_IYtk3ozbAO {
    border: 4px solid rgba(255, 255, 255, 0.3);
    /* Semi-transparent white */
    border-top: 4px solid #4BB57B;
    /* White */
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: u7nNNN6ZFK96cKiT0MFg 1s linear infinite;
  }
  .Q4AfaRzgpnJDjLgEoGEw {
    border: 3px solid rgba(255, 255, 255, 0.3);
    /* Semi-transparent white */
    border-top: 3px solid #ffffff;
    /* White */
    border-radius: 50%;
    width: 30px;
    height: 30px;
    animation: u7nNNN6ZFK96cKiT0MFg 1s linear infinite;
  }
  
  @keyframes u7nNNN6ZFK96cKiT0MFg {
    0% {
      transform: rotate(0deg);
    }
  
    100% {
      transform: rotate(360deg);
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/Loader/loader.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,2BAA2B;IAC3B,eAAe;EACjB;;EAEA;IACE,0CAA0C;IAC1C,2BAA2B;IAC3B,6BAA6B;IAC7B,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kDAAkC;EACpC;EACA;IACE,0CAA0C;IAC1C,2BAA2B;IAC3B,6BAA6B;IAC7B,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kDAAkC;EACpC;;EAEA;IACE;MACE,uBAAuB;IACzB;;IAEA;MACE,yBAAyB;IAC3B;EACF","sourcesContent":[".backdrop {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    /* Semi-transparent black */\n    z-index: 120000;\n  }\n  \n  .spinner {\n    border: 4px solid rgba(255, 255, 255, 0.3);\n    /* Semi-transparent white */\n    border-top: 4px solid #4BB57B;\n    /* White */\n    border-radius: 50%;\n    width: 50px;\n    height: 50px;\n    animation: spin 1s linear infinite;\n  }\n  .spinner2 {\n    border: 3px solid rgba(255, 255, 255, 0.3);\n    /* Semi-transparent white */\n    border-top: 3px solid #ffffff;\n    /* White */\n    border-radius: 50%;\n    width: 30px;\n    height: 30px;\n    animation: spin 1s linear infinite;\n  }\n  \n  @keyframes spin {\n    0% {\n      transform: rotate(0deg);\n    }\n  \n    100% {\n      transform: rotate(360deg);\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backdrop": `XrBI9Yj7LgUu_aiMBw1B`,
	"spinner": `J6k2sMuAK_IYtk3ozbAO`,
	"spin": `u7nNNN6ZFK96cKiT0MFg`,
	"spinner2": `Q4AfaRzgpnJDjLgEoGEw`
};
export default ___CSS_LOADER_EXPORT___;
